import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

const sizeClass = {
  sm: 'bbg-litra-logo--sm',
  md: 'bbg-litra-logo--md',
  lg: 'bbg-litra-logo--lg',
}

export type LitraLogoProps = {
  className?: string
  size?: keyof typeof sizeClass
}

/** Brand wordmark: gradient LITRA! (Poppins Black italic). */
export function LitraLogo({ className, size = 'md' }: LitraLogoProps) {
  return (
    <span className={cn('bbg-litra-logo', sizeClass[size], className)} aria-label="LITRA!">
      LITRA!
    </span>
  )
}

/** Inline gradient text for "LITERA" / "LITRA!" mentions. */
export function LitraGradientText({
  className,
  children = 'LITERA',
}: {
  className?: string
  children?: ReactNode
}) {
  return <span className={cn('bbg-litra-gradient-text', className)}>{children}</span>
}
